// Single source of truth for date/time display formats across the app.
// Values are Angular DatePipe/formatDate format strings.
export const DATE_FORMATS = {
  date: 'dd/MM/yyyy',
  dateTime: 'dd/MM/yyyy HH:mm',
  time: 'HH:mm',
} as const;
